/** @module The collection's headline figures, shared by the badges, the start screen and lists. */
import { useQuery } from "@tanstack/react-query";

import { api, problemFrom } from "@/api/client";

/** Same key and shape as the start screen's own fetch: the two share one cache entry. */
export function useSummary(enabled = true) {
  return useQuery({
    queryKey: ["dashboard", "summary"],
    queryFn: async () => {
      const { data, response } = await api.GET("/api/v1/dashboard/summary", {});
      if (!data) throw problemFrom(response);
      return data;
    },
    enabled,
    refetchInterval: 60_000,
  });
}

/** Open review cases for the badges in the sidebar, the tab bar and "Mehr". */
export function useOpenReviews(enabled: boolean): number {
  return useSummary(enabled).data?.open_reviews ?? 0;
}
